import { render } from "./ProductGCHistory.vue?vue&type=template&id=7c030c8d&ts=true"
import script from "./ProductGCHistory.vue?vue&type=script&lang=ts"
export * from "./ProductGCHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__